import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useTranslation } from "react-i18next";
import { Tooltip, TooltipPortal, Button } from "@animech/ui";
import { useTheme } from "@emotion/react";
import * as Styled from "./toolbar.style";
import { VacuumPumpIcon, greyVacuumPumpIconColors, } from "ui/components/elements/icons/vacuum-pump";
import { DecentralizedGripPositionIcon } from "ui/components/elements/icons/decentralized-grip-position";
import { CentralizedGripPositionIcon } from "ui/components/elements/icons/centralized-grip-position";
import { TubeConnectionIcon } from "ui/components/elements/icons/tube-connection";
import { PlusIconWithBackground } from "ui/components/elements/icons/plus-with-background";
import { useAppDispatch, useAppSelector, selectors, actions } from "store";
var ToolbarButtonIcon;
(function (ToolbarButtonIcon) {
    ToolbarButtonIcon["GRIP_POSITION"] = "gripPosition";
    ToolbarButtonIcon["TUBE_CONNECTION"] = "tubeConnection";
    ToolbarButtonIcon["VACUUM_PUMP"] = "vacuumPump";
})(ToolbarButtonIcon || (ToolbarButtonIcon = {}));
export var Toolbar = function () {
    var t = useTranslation().t;
    var dispatch = useAppDispatch();
    var onAddGripPosition = function () {
        dispatch(actions.addGripPosition());
    };
    var onAddCentralizedVacuumPump = function () {
        dispatch(actions.addCentralizedPump());
    };
    var onAddConnectionPoint = function () {
        dispatch(actions.addTubeConnection());
    };
    var canAddGripPosition = useAppSelector(selectors.selectCanAddGripPosition);
    var canAddCentralizedVacuumPump = useAppSelector(selectors.selectCanAddCentralizedPump);
    var isCentralizedPumpLimitReached = useAppSelector(selectors.selectIsCentralizedPumpLimitReached);
    var canAddTubeConnection = useAppSelector(selectors.selectCanAddTubeConnection);
    var isCentralizedSystem = useAppSelector(selectors.selectIsCentralizedSystem);
    var icons = {
        gripPosition: isCentralizedSystem ? (_jsx(CentralizedGripPositionIcon, { size: 36 })) : (_jsx(DecentralizedGripPositionIcon, { size: 36 })),
        tubeConnection: _jsx(TubeConnectionIcon, { size: 36 }),
        vacuumPump: (_jsx(VacuumPumpIcon, { size: 36, colors: canAddCentralizedVacuumPump ? undefined : greyVacuumPumpIconColors })),
    };
    var toolbarButtons = [
        {
            icon: ToolbarButtonIcon.GRIP_POSITION,
            onClick: onAddGripPosition,
            enabled: canAddGripPosition,
            tooltip: t("sidebar.toolbar.add_grip_position"),
        },
        {
            icon: ToolbarButtonIcon.TUBE_CONNECTION,
            onClick: onAddConnectionPoint,
            enabled: canAddTubeConnection,
            tooltip: t("sidebar.toolbar.add_connection_point"),
        },
        {
            icon: ToolbarButtonIcon.VACUUM_PUMP,
            onClick: onAddCentralizedVacuumPump,
            enabled: canAddCentralizedVacuumPump,
            tooltip: t("sidebar.toolbar.add_pump"),
            disabledTooltip: isCentralizedPumpLimitReached
                ? t("sidebar.toolbar.max_pumps_reached")
                : undefined,
        },
    ];
    var theme = useTheme();
    return (_jsx(Styled.Toolbar, { children: _jsx("div", { className: "".concat(Styled.prefix), children: toolbarButtons.map(function (button) {
                var isDisabled = !button.enabled;
                if (isDisabled && !button.disabledTooltip)
                    return null;
                return (_jsx(TooltipPortal, { anchorElement: _jsxs(Button, { rootAttributes: {
                            onMouseDown: function (event) { return event.stopPropagation(); },
                            /* `aria-disabled` rather than `disabled`: a disabled
                               button gets no hover, and the tooltip is what says
                               why it cannot be used. */
                            "aria-disabled": isDisabled,
                        }, onClick: function () {
                            if (isDisabled)
                                return;
                            button.onClick();
                        }, appearance: "text", rounded: true, children: [_jsx(Styled.ToolbarPlusIcon, { children: _jsx(PlusIconWithBackground, { size: 18, color: isDisabled
                                        ? theme.colors.palette.grey[500]
                                        : theme.colors.palette.green[500] }) }), icons[button.icon]] }), toggleEvent: "hover", placement: "bottom", children: _jsx(Tooltip, { color: "neutral", children: isDisabled ? button.disabledTooltip : button.tooltip }) }, button.icon));
            }) }) }));
};
